import styled from 'styled-components'

import { BaseButtonStyled } from '@ui/elements/Button'

export const PresetsContainerStyled = styled.div`
  padding: ${(props) => props.theme.space.medium};

  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.small};

  ${BaseButtonStyled} + ${BaseButtonStyled} {
    margin-left: 0;
  }
`
